<label>
  <input type="radio" [value]="value" [name]="name" [tabIndex]="tabIndex" [required]="required" [disabled]="disabled" [checked]="checked" (blur)="onTouched()" (change)="onInputChange($event)">
  <span>
    <ng-content></ng-content>
  </span>
</label>
